import React from "react";
import { HeroSection,WhatIsFinxpo} from "./index";

const Home = () => {
  return (
    <div>
      <HeroSection />
      {/* <DownHomeSection /> */}
      <WhatIsFinxpo />
    </div>
  );
};

export default Home;
